import { Box, Skeleton } from '@mui/material';
import DetectMobileHelper from '../../../helpers/detect-mobile.helper';

const VariationCard = () => {
  return <>
    {DetectMobileHelper.isMobile() ?
      <Box className='variation-card-ghost light-boxed d-flex flex-column mb-3' >
        <Skeleton width='100%' height='50%' variant='rounded' animation='wave' />
        <Box className='d-flex flex-column w-100 h-50' >
          <Skeleton className='my-1 mx-2' width='95%' height='20%' animation='wave' />
          <Skeleton className='mx-2' width='95%' height='60%' animation='wave' />
          <Skeleton className='my-1 mx-2' width='95%' height='20%' animation='wave' />
        </Box>
      </Box>
      :
      <Box className='variation-card-ghost d-flex flex-row boxed mb-3' >
        <Skeleton width='20%' height='100%' variant='rounded' animation='wave' />
        <Box className='d-flex flex-column w-100 h-100' >
          <Skeleton className='my-1 mx-2' width='98%' height='20%' animation='wave' />
          <Skeleton className='mx-2' width='98%' height='60%' animation='wave' />
          <Skeleton className='my-1 mx-2' width='98%' height='20%' animation='wave' />
        </Box>
      </Box>
    }
  </>;
}

export default VariationCard;
